import Vue from 'vue'
import router from './router'
import iView from 'iview';
import axios from './config/http.js'
import * as filters from './util/filter'
import * as qiniu from 'qiniu-js'

import VueQuillEditor from 'vue-quill-editor'

import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import VueRouter from 'vue-router'
import * as types from './store/types'
import store from './store/store'
import * as cookie from './util/util'
import 'babel-polyfill'
import VueEcharts from 'vue-echarts'
import ElementUI from 'element-ui'
import Moment from 'moment'
import VueResource from 'vue-resource'
import vSelect from 'vue-select'
import * as downLoad from './util/downLoad'
import imgPreview from '@/components/imgPreview'
 


// 地图
import BaiduMap from 'vue-baidu-map'
// collapse 展开折叠
import CollapseTransition from 'element-ui/lib/transitions/collapse-transition';
import { getAllSysCode } from '@/api/system'
import 'element-ui/lib/theme-chalk/index.css'
import './assets/icon/iconfont.css'
import './assets/hohofastIcon/iconfont.css'

import App from './App'
Vue.use(ElementUI)
Vue.use(VueResource)
Vue.use(qiniu)
Vue.use(VueQuillEditor, /* { default global options } */)
Vue.use(imgPreview)

// 地图
Vue.use(BaiduMap, {
  // ak 是在百度地图开发者平台申请的密钥 详见 http://lbsyun.baidu.com/apiconsole/key */
  ak: 'U4h3ZxQV58uB3ip3fDppK3WctyvQkD5Y'
})
Vue.config.productionTip = false

// Vue.prototype.$api = api // 绑定API方法到全局

Vue.prototype.axios = axios//
Vue.prototype.types = types
Vue.prototype.cookie = cookie
Vue.prototype.downLoad = downLoad
Vue.prototype.filters = filters
Vue.filter('date', filters.formatDate)
Vue.filter('getTel', filters.getTel)
// Vue.prototype.upLoadUrl = '/upload'

Vue.prototype.moment = Moment
Vue.use(iView)

Vue.component('chart', VueEcharts)
Vue.component('v-select', vSelect)
Vue.component(CollapseTransition.name, CollapseTransition)
// 页面刷新时，重新赋值token
if (localStorage.getItem('token')) {
    store.commit('set_token', localStorage.getItem('token'))
}
Vue.config.devtools = true;

//注册全局钩子
router.beforeEach((to, from, next) => {
  let toPath = to.path
  let fromPath = from.path
 if(to.meta.requireAuth) {
  	if (store.state.token) {  // 通过vuex state获取当前的token是否存在
      next();
    }
    else {
      next({
          path: '/',
          query: {redirect: to.fullPath}  // 将跳转的路由path作为参数，登录成功后跳转到该路由
      })
    }
  }else if(store.state.token){
	  if(to.path === '/'){
		  next({
			  path: '/welcome',
			  query: {redirect: to.fullPath} 
		  })
	  }else if(to.path=="/loginOut"){
		   next({
			  path: '/'
		  })
	  }else{
		  next()
	  }
  }else {
    next()
  }
})

getAllSysCode({
    'startRows' : 1,
    'pageSize' : 10000
}).then(resp => {
  if(resp.data.results){
      const data = resp.data.results
      Vue.prototype.SYS_CODE = data
  }
  new Vue({
    el: '#app',
    router,
    store,
    template: '<App/>',
    components: { App }
  })
})
/* eslint-disable no-new */
Vue.filter('sysCodeFileter',function(code, type){

  if (code === null) {
      return ''
  }
  const typeArr = Vue.prototype.SYS_CODE
  for (var i in typeArr) {
      const element = typeArr[i]
      if (element.paraType == type && element.paraValue == code) {
          return element.paraName
      }
  }
  return code

})



// WEBPACK FOOTER //
// ./src/main.js